import { GetterTree } from 'vuex';
import IFleetState from './types/IFleetState';
import IRootState from '@/store/types/IRootState';

const getters: GetterTree<IFleetState, IRootState> = {};

export default getters;
